<script setup>
import { computed, ref } from 'vue'

const props = defineProps({
  item: { type: Object, required: true },
  values: { type: Object, required: true },
  error: { type: String, default: '' },
  labels: { type: Object, required: true },
})
const emit = defineEmits(['update'])
const startInput = ref(null)
const endInput = ref(null)
const idBase = computed(() => `product-range-${String(props.item.group).replace(/[^a-z0-9_-]/gi, '-')}`)
const helperId = computed(() => `${idBase.value}-helper`)
const errorId = computed(() => `${idBase.value}-error`)
const describedBy = computed(() => props.error ? `${helperId.value} ${errorId.value}` : helperId.value)

function update(parameter, event) {
  emit('update', { group: props.item.group, name: parameter.name, value: event.target.value })
}

function focus(parameterName) {
  if (parameterName === props.item.end.name) endInput.value?.focus()
  else startInput.value?.focus()
}

defineExpose({ focus })
</script>

<template>
  <fieldset class="product-range-field" :aria-describedby="describedBy">
    <legend>{{ labels.title }}</legend>
    <div class="product-range-inputs">
      <label>
        <span>{{ labels.start }}<em v-if="item.start.mandatory"> *</em></span>
        <input
          ref="startInput"
          :value="values[item.start.name]"
          type="number"
          step="1"
          inputmode="numeric"
          :aria-invalid="Boolean(error)"
          :aria-describedby="describedBy"
          @input="update(item.start, $event)"
        >
      </label>
      <label>
        <span>{{ labels.end }}<em v-if="item.end.mandatory"> *</em></span>
        <input
          ref="endInput"
          :value="values[item.end.name]"
          type="number"
          step="1"
          inputmode="numeric"
          :aria-invalid="Boolean(error)"
          :aria-describedby="describedBy"
          @input="update(item.end, $event)"
        >
      </label>
    </div>
    <small :id="helperId" class="product-range-helper">{{ labels.hint }}</small>
    <p v-if="error" :id="errorId" class="product-range-error" role="alert" aria-live="polite">{{ error }}</p>
  </fieldset>
</template>
